export default __webpack_public_path__ + "static/SR USA - Non-GMO Project Verified (en Ingelés) - Certificado-8f9c026b3fc6437487c87818300f9dae.pdf";